import React, { useState } from "react";
import useAsync from "../../hooks/useAsync";
import { Link } from "react-router-dom";
import BlogServices from "../../services/BlogServices";
import Footer from "./Common/footer";

function Blog() {
  const { data, error, isLoading } = useAsync(BlogServices.getBlogs);
  const [showAll, setShowAll] = useState(false);
  const blogs = data?.data || [];

  // Show only 6 blogs initially
  const displayedBlogs = showAll ? blogs : blogs.slice(0, 6);

  return (
    <>
      <section className="notification-section package-details-section popular-package-section welcome-section mt-0">
        <div className="container">
          <div className="tour-package-outer heading-outer d-flex">
            <div className="main-heading-outer">
              <h3 className="main-heading" style={{ color: "white" }}>
                Our Blogs
              </h3>
            </div>
          </div>
        </div>
      </section>

      <section className="welcome-section">
        <div className="container">
          <div className="breadcrumb-outer">
            <ul className="breadcrumb">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>Blogs</li>
            </ul>
          </div>

          <div className="heading-outer d-flex">
            <div className="main-heading-outer">
              <h3 className="main-heading">Latest Blogs</h3>
            </div>
            {blogs.length > 6 && (
              <div className="view-all-btn">
                <button
                  onClick={() => setShowAll(!showAll)}
                  className="toggle-btn"
                >
                  {showAll ? "View Less" : "View All"}
                </button>
              </div>
            )}
          </div>

          <div className="row g-4">
            {displayedBlogs.map((blog) => (
              <div className="col-md-4" key={blog._id}>
                <div className="offer-card">
                  {/* <Link to={`/blog-details/${btoa(blog._id)}`} className="card-link"> */}
                  <Link
                    to={`/blog/${blog.title.replace(/\s+/g, "-")}`}
                    className="card-link"
                  >
                    <div
                      className="card-img1-container"
                      style={{ position: "relative" }}
                    >
                      <img
                        src={`${process.env.REACT_APP_URL || ""}${
                          blog.images[0]
                        }`}
                        alt={blog.title}
                        className="card-img-top"
                      />
                    </div>
                  </Link>
                  <div className="card-body">
                    <Link
                      to={`/blog/${blog.title.replace(/\s+/g, "-")}`}
                      className="card-link"
                    >
                      <h5 className="heading">{blog.title}</h5>
                    </Link>
                    <br />
                    <p className="sub-heading">
                      <span>
                        {" "}
                        <b>Author:</b>
                      </span>{" "}
                      {blog.author} <br />{" "}
                      <span>
                        <b>Date:</b>
                      </span>{" "}
                      {new Date(blog.createdAt).toLocaleDateString()}
                    </p>
                    <p className="content"></p>{" "}
                    {/* Using the "content" class */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Blog;
